import { createStyles } from '@mantine/core'

const useDefaultImplementationStyles = createStyles((theme) => ({
  wrappingBox: {
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,

    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: theme.spacing.sm,
    overflow: 'hidden',
  },
}))

export default useDefaultImplementationStyles
